import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Star } from "lucide-react";
import { menuHighlights } from "../../mock";

export default function MenuHighlights() {
  return (
    <section className="relative bg-[#0d2929] text-white py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="divider-ornament text-spice-gold">Signature Selection</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium mt-5 mb-4 leading-[1.1]">
            Menu <em className="italic text-spice-gold font-light">Highlights</em>
          </h2>
          <p className="text-white/70 text-base md:text-lg leading-relaxed">
            A taste of what awaits — our most loved dishes, where ocean-fresh seafood meets
            globally inspired technique. Every plate is crafted in-house and served with care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-8">
          {menuHighlights.map((dish) => (
            <div key={dish.id} className="menu-card group bg-[#0a2020] border border-white/8">
              <div className="relative overflow-hidden h-64">
                <img
                  src={dish.image}
                  alt={dish.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a2020] via-transparent to-transparent opacity-80" />
                {dish.signature && (
                  <div className="absolute top-4 left-4 bg-spice-gold text-[#0d2929] px-3 py-1 text-[10px] font-bold tracking-[0.2em] uppercase flex items-center gap-1">
                    <Star size={10} fill="currentColor" /> Signature
                  </div>
                )}
                <div className="absolute top-4 right-4 bg-[#0d2929]/90 backdrop-blur text-spice-gold px-3 py-1 font-display text-lg">
                  {dish.price}
                </div>
              </div>
              <div className="p-6">
                <div className="text-spice-gold/80 text-[10px] tracking-[0.3em] uppercase mb-2">
                  {dish.category}
                </div>
                <h3 className="font-display text-2xl text-white mb-2">{dish.name}</h3>
                <p className="text-white/65 text-sm leading-relaxed">{dish.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/menu">
            <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-10 h-13 h-14">
              View Full Menu
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
